import TruckCard from './TruckCard';
export default TruckCard;
